import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class ProductGet extends PlusComponent {
  constructor(props) {
    super(props, "contentProduct");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentProduct"></ContentSettings>
        </div>
      )
    }
}

export default ProductGet;